import React from "react"
import { ChildrenNode, Matcher, MatchResponse, Node } from "interweave"
import i18n from "@/lib/i18n/i18n"

export interface SlickShiftShareRouteHereWeGoMatcherProps {
  href: string
}

export class SlickShiftShareRouteHereWeGoMatcher extends Matcher<SlickShiftShareRouteHereWeGoMatcherProps> {
  match(string: string): MatchResponse<{ href: string }> | null {
    const pattern =
      /https:\/\/(?:api\.slickshift\.ai|api\.trickswift\.eu)\/public\/shared_route_here\?secret=[a-zA-Z0-9_-]+/i

    const result = string.match(pattern)

    if (!result) {
      return null
    }

    return {
      index: result.index!,
      length: result[0].length,
      match: result[0],
      href: result[0],
      valid: true,
    }
  }

  replaceWith(
    children: ChildrenNode,
    props: SlickShiftShareRouteHereWeGoMatcherProps,
  ): Node {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:no-underline"
      >
        🚚 {i18n.t("maps.routeLinks.openInHereWeGo")}
      </a>
    )
  }

  asTag(): string {
    return "a"
  }
}
